<template>
    <div class="form-content">
        <h1>Zmena profilových údajov</h1>

        <div class="form"> 
            <div>
                {{this.$api.login.data.user.email}}<br /><br />
            </div>
            <app-input :f-v="$v" f-name="name" label="Meno" v-model="name"></app-input>
            <app-input :f-v="$v" f-name="lastname" label="Priezvisko" v-model="lastname"></app-input>
            <app-switch :f-v="$v" f-name="change_passwd" label="Zmeniť heslo" v-model="change_passwd"></app-switch>
            <div v-show="change_passwd">
                <app-input :f-v="$v" type="password" f-name="passwd" label="Heslo" v-model="passwd"></app-input>
                <app-input :f-v="$v" type="password" f-name="confirm_passwd" label="Potvrdiť heslo" v-model="confirm_passwd"></app-input>
            </div>
            <div>
                <button @click="save">Uložiť zmeny</button>
            </div>
        </div>
    </div>
</template>

<script>
    import FormBase from "../../elements/FormBase";

    import {required, requiredIf, email, sameAs} from 'vuelidate/lib/validators';
    export default {
        components: {

        },
        mixins: [FormBase],
        data() {
            return {
                loading: false,
                name: this.$api.login.data.user.name,
                lastname: this.$api.login.data.user.lastname,
                change_passwd: false,
                passwd: null,
                confirm_passwd: null
            };
        },
        mounted() {
        },
        created() {
        },
        methods: {
            save() {
                this.$v.$touch();
                this.$api.helpers.sendForm(this.$v, (res) => {
                    if (res) {
                        this.loading = true;
                        this.$api.server.post("api/public/profile", {
                            "name": this.name,
                            "lastname": this.lastname,
                            "change_passwd": this.change_passwd,
                            "passwd": this.passwd,
                            "confirm_passwd": this.confirm_passwd,
                        }).then((res) => {
                            this.$api.toaster.success({txt: "Váš profil bol upravený !"});
                        }).catch(() => {

                        }).finally(() => {

                        });
                    }
                });

            }
        },
        validations() {
            return {
                name: {required},
                lastname: {required},
                change_passwd: {},
                passwd: {requiredIf: requiredIf("change_passwd")},
                confirm_passwd: {sameAs: sameAs("passwd"), requiredIf: requiredIf("change_passwd")}
            };
        }

    };
</script>
<style lang="css">

</style>



// WEBPACK FOOTER //
// src/public_app/pages/profile/Form.vue